module.exports = __webpack_public_path__ + "static/media/suture_tails.6fe15d28.gif";